<template>
	<div>
		<v-row class="mt-5" >
			<v-col cols="6">
				<v-toolbar color="primary" dark>
					<v-toolbar-title>Add Partner</v-toolbar-title>
				</v-toolbar>
				<v-card>
					<v-card-text>
						<v-row  >
							<v-col cols="6">
								<v-text-field label="Name" v-model="name" name="name" class="required"
									v-validate="'required'" :error-messages="errors.collect('name')" required></v-text-field>
							</v-col>
							<v-col cols="6" />
							<v-col cols="12">
								<v-textarea
									label="Description"
									v-model="description"
								></v-textarea>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn @click="add" color="primary" :disabled="errors.any() || adding" :loading="adding">Add Partner</v-btn>
					</v-card-actions>
				</v-card>

			</v-col>
		</v-row>
	</div>

</template>

<script>
import analysisApi from "../../analysisApi";
import { actionTypes } from "../../store-types";

export default {
	data() {
		return {
			description: null,
			name: null,
			adding: false,
		};
	},
	methods: {
		add() {
			this.$validator.validateAll()
				.then((valid) => {
					if (!valid) {
						return Promise.resolve();
					}

					this.adding = true;
					return analysisApi.addPartner(this.name, this.description)
						.then(() => {
							this.$emit("add");
							this.$store.dispatch(actionTypes.LOAD_CONFIG);
							this.description = null;
							this.name = null;
							this.$validator.reset();
							this.showToast("success", "Partner Added");
						})
						.catch((e) => {
							this.showError(e);
						})
						.finally(() => {
							this.adding = false;
						});
				});
		},
	},
};
</script>
